export const CheckedIcon2FA = () => (
  <svg
    width="48"
    height="28"
    viewBox="0 0 48 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 0.5C6.06 0.5 0 6.5525 0 14C0 21.4475 6.06 27.5 13.5 27.5H34.5C41.9355 27.5 48 21.4355 48 14C48 6.5645 41.9355 0.5 34.5 0.5H13.5ZM34.5 3.5C40.3185 3.5 45 8.1815 45 14C45 19.8185 40.3185 24.5 34.5 24.5C28.6815 24.5 24 19.8185 24 14C24 8.1815 28.6815 3.5 34.5 3.5Z"
      fill="url(#paint0_linear_11962_269)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11962_269"
        x1="0"
        y1="14.0009"
        x2="48.0025"
        y2="14.0009"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F12E11"/>
        <stop offset="1" stop-color="#F12E11"/>
      </linearGradient>
    </defs>
  </svg>
);
